import uitvraag from '../../uitvraag.js';

const uitvraagP710StopLossNaverrekend = {

	init() {

		uitvraag.init();

		// Verkrijg stap vanuit de DOM
		var stap = document.querySelector('div.step-tabs ul.nav.nav-tabs').getAttribute('data-tab-active');
		document.querySelector('.nav-tabs-active-' + stap + ' .nav-link').classList.add('active');

		// Definieer submitbutton
		var submitButton = $('form[data-validate] button.btn-submit');

		// Toon modal in stap 4
		if (stap == 4) {
			$('input[name=arborapportage]').on('change', function() {
				if ($(this).val() == '') {
					submitButton.attr('type', 'submit');
					submitButton.attr('disabled', 'true');
				} else {
					submitButton.attr('type', 'button');
					submitButton.removeAttr('disabled');
				}
			});
		}

		// Definieer of de cofirmation modal getoond moet worden
		if (stap == 2) {
			$('select[name=indienenZonderDeclaratie]').on('change', function() {
				if ($(this).val() == 'j' && uitvraag.checkSubmitAllowed()) {
					submitButton.attr('type', 'button');
				} else {
					submitButton.attr('type', 'submit');
				}
			});

			$('form.form-uitvraag input[type=file]').on('change', function() {
				$('select[name=indienenZonderDeclaratie]').trigger('change');
			});
		}

		// Open bevestigingsmodal
		$('body').on('click', 'button[type=button].btn-submit', function() {
			$('#modalBevestigen').modal('show', {
				keyboard: false,
				backdrop: 'static'
			});
		});

		// Bind functie die de ingevoerde gegevens in het formulier submit aan button in modal
		$('#modalBevestigen').on('click', '.btn-submit-confirm', function() {
			uitvraag.submitForm();
		});

	},

	// Functie die de ingevoerde gegevens in het formulier submit
	submitForm: function() {
		$('#modalBevestigen').modal('hide');
		$('#loadingModal').modal('show', {
			keyboard: false,
			backdrop: 'static'
		});
		setTimeout(function() {
			$('form[data-validate]')[0].submit();
		}, 200);
	},

	// Function om te controleren of alle checkboxes zijn aangevinkt en enable button
	checkSubmitAllowed: function() {
		var allowed = true;
		$('form.form-uitvraag input[type=file]').each(function() {
			if ($(this).val() == '') {
				allowed = false;
			}
		});
		return allowed;
	}

};

export default uitvraagP710StopLossNaverrekend;
